var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-avatar"},[_c('div',{staticClass:"icon-wrapper"},[_c('b-icon',{attrs:{"font-scale":"1.5","icon":_vm.isSimulatingUser ? 'people-fill' : 'person-fill'}})],1),_vm._v(" "+_vm._s(_vm.currentUser)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }